import React, { useState, useEffect, useContext } from "react";
import { TransactionDetail, LabelDetail, StatusLabel, ReceiptBtn } from "./styles";

import serverProvider from "../../../../../providers/serverProvider";

import { lumCalc } from "../../../../../utils/functions/lumCalc";

import DownloadLogo from "../../../../../components/DownloadLogo";
import CircleLoader from "../../../../../components/CircleLoader/CircleLoader";

import { InformationPopUpContext } from "../../../../../contexts/informationPopUp";

// Outros SVG's
import pixImg from "../../../../../assets/images/pixIcon.svg";
import calendarImg from "../../../../../assets/images/calendarIcon.svg";
import clockImg from "../../../../../assets/images/clockIcon.svg";

// SVG dos mini cartões
import visaImg from "../../../../../assets/images/visaIcon.svg";
import mastercardImg from "../../../../../assets/images/mastercardIcon.svg";
import amexImg from "../../../../../assets/images/amexIcon.svg";
import eloImg from "../../../../../assets/images/eloIcon.svg";
import hipercardImg from "../../../../../assets/images/hipercardIcon.svg";

const toMoneyFormat = (value) => {
  return Number(value / 100).toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
  });
};

const showPaymentType = (payment) => {
  const esitef_type = {
    C: "Cartão de crédito",
    O: "PIX",
  };

  const link_type = {
    credCard: "Cartão de crédito",
    pix: "PIX",
  };

  return esitef_type[payment] || link_type[payment] || "";
};

const showPaymentIcon = (type) => {
  const icon = {
    1: visaImg,
    2: mastercardImg,
    3: amexImg,
    41: eloImg,
    5: hipercardImg,
    440: pixImg,
  };

  return icon[type] || "";
};

const showDateTime = (type) => {
  const _date = new Date().toLocaleDateString("pt-br");
  const _time = new Date().toLocaleTimeString("pt-br");

  const obj = {
    Date: _date,
    Time: _time.slice(0, 5),
  };

  return obj[type] || "";
};

const TransactionDetails = (props) => {
  const [reference, setReference] = useState("");
  const { showInformationPopUp } = useContext(InformationPopUpContext);
  const colorLetterButton = lumCalc(props.reiceptButtonColor || "#ffffff") > 128 ? "black" : "white";

  const _date = props.paymentData.payment_date?.split("T")[0] || showDateTime("Date");
  const _time = props.paymentData.payment_date?.split("T")[1] || showDateTime("Time");
  const order_id = props.orderId || false;

  const receipt_payload = {
    type: props.paymentData.type || "CREDITO",
    establishment: props.paymentData.establishment,
    payment_date: _date,
    payment_time: _time,
    order_id: order_id,
    transaction_id: "",
    authorization_number: props.paymentData.authorization_number,
    amount: props.paymentData.amount,
    emrpay_usn: props.paymentData.emrpay_usn,
  };

  useEffect(() => {
    if (props.paymentStatus.status === "success") {
      serverProvider()
        .createReceipt(receipt_payload)
        .then((res) => {
          setReference(res.download);
        })
        .catch((e) => {
          console.log("[e]", e);
        });
    }
  }, []);

  const downloadReceipt = () => {
    if (!reference) return;

    window.open(reference, "_blank");
  };

  return (
    <TransactionDetail>
      <span className="amount">{toMoneyFormat(props.paymentData.amount)}</span>
      <LabelDetail>
        <span>Forma de pagamento:</span>
        <div className="info-label">
          <img src={showPaymentIcon(props.paymentData.authorizer_id)} />
          <span className="value-detail">{showPaymentType(props.paymentData.payment_type)}</span>
          {props.paymentData.type !== "PIX" && props.paymentData?.installment > 1 && (
            <span>{`(${props.paymentData.installment}x)`}</span>
          )}
        </div>
      </LabelDetail>
      <LabelDetail>
        <span>Status:</span>
        <StatusLabel status={props.paymentStatus.status}>{props.paymentStatus.message}</StatusLabel>
      </LabelDetail>
      <LabelDetail>
        <span>Data/Hora:</span>
        <div className="info-label">
          <img src={calendarImg} />
          <span className="value-detail">{_date}</span>
          <img src={clockImg} />
          <span className="value-detail">{_time}</span>
        </div>
      </LabelDetail>

      {props.paymentStatus.status === "success" && (
        <ReceiptBtn
          type="submit"
          onClick={downloadReceipt}
          bgColor={props.reiceptButtonColor || "#F1B434"}
          letterColor={colorLetterButton}
        >
          {reference ? (
            <>
              <strong>Baixar comprovante</strong>
              <DownloadLogo bgColor={props.reiceptButtonColor || "#ffffff"} />
            </>
          ) : (
            <CircleLoader width="23" height="23" fill={colorLetterButton} />
          )}
        </ReceiptBtn>
      )}
    </TransactionDetail>
  );
};

export default TransactionDetails;
